 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPS9780795325090_EPUB_CVI_R1 from '@/components/OEBPS/9780795325090_epub_cvi_r1'
 import LOVE_1 from '@/components/love_1'
 import OEBPS9780795325090_EPUB_TP_R1 from '@/components/OEBPS/9780795325090_epub_tp_r1'
 import OEBPS9780795325090_EPUB_COP_R1 from '@/components/OEBPS/9780795325090_epub_cop_r1'
 import OEBPS9780795325090_EPUB_DED_R1 from '@/components/OEBPS/9780795325090_epub_ded_r1'
 import OEBPS9780795325090_EPUB_TOC_R1 from '@/components/OEBPS/9780795325090_epub_toc_r1'
 import OEBPS9780795325090_EPUB_ATN_R1 from '@/components/OEBPS/9780795325090_epub_atn_r1'
 import OEBPS9780795325090_EPUB_P01_R1 from '@/components/OEBPS/9780795325090_epub_p01_r1'
 import OEBPS9780795325090_EPUB_C01_R1 from '@/components/OEBPS/9780795325090_epub_c01_r1'
 import OEBPS9780795325090_EPUB_C02_R1 from '@/components/OEBPS/9780795325090_epub_c02_r1'
 import OEBPS9780795325090_EPUB_C03_R1 from '@/components/OEBPS/9780795325090_epub_c03_r1'
 import OEBPS9780795325090_EPUB_C04_R1 from '@/components/OEBPS/9780795325090_epub_c04_r1'
 import OEBPS9780795325090_EPUB_C05_R1 from '@/components/OEBPS/9780795325090_epub_c05_r1'
 import OEBPS9780795325090_EPUB_C06_R1 from '@/components/OEBPS/9780795325090_epub_c06_r1'
 import OEBPS9780795325090_EPUB_C07_R1 from '@/components/OEBPS/9780795325090_epub_c07_r1'
 import OEBPS9780795325090_EPUB_C08_R1 from '@/components/OEBPS/9780795325090_epub_c08_r1'
 import OEBPS9780795325090_EPUB_C09_R1 from '@/components/OEBPS/9780795325090_epub_c09_r1'
 import OEBPS9780795325090_EPUB_C10_R1 from '@/components/OEBPS/9780795325090_epub_c10_r1'
 import OEBPS9780795325090_EPUB_C11_R1 from '@/components/OEBPS/9780795325090_epub_c11_r1'
 import OEBPS9780795325090_EPUB_P02_R1 from '@/components/OEBPS/9780795325090_epub_p02_r1'
 import OEBPS9780795325090_EPUB_C12_R1 from '@/components/OEBPS/9780795325090_epub_c12_r1'
 import OEBPS9780795325090_EPUB_C13_R1 from '@/components/OEBPS/9780795325090_epub_c13_r1'
 import OEBPS9780795325090_EPUB_C14_R1 from '@/components/OEBPS/9780795325090_epub_c14_r1'
 import OEBPS9780795325090_EPUB_C15_R1 from '@/components/OEBPS/9780795325090_epub_c15_r1'
 import OEBPS9780795325090_EPUB_C16_R1 from '@/components/OEBPS/9780795325090_epub_c16_r1'
 import OEBPS9780795325090_EPUB_C17_R1 from '@/components/OEBPS/9780795325090_epub_c17_r1'
 import OEBPS9780795325090_EPUB_P03_R1 from '@/components/OEBPS/9780795325090_epub_p03_r1'
 import OEBPS9780795325090_EPUB_C18_R1 from '@/components/OEBPS/9780795325090_epub_c18_r1'
 import OEBPS9780795325090_EPUB_C19_R1 from '@/components/OEBPS/9780795325090_epub_c19_r1'
 import OEBPS9780795325090_EPUB_C20_R1 from '@/components/OEBPS/9780795325090_epub_c20_r1'
 import OEBPS9780795325090_EPUB_C21_R1 from '@/components/OEBPS/9780795325090_epub_c21_r1'
 import OEBPS9780795325090_EPUB_C22_R1 from '@/components/OEBPS/9780795325090_epub_c22_r1'
 import OEBPS9780795325090_EPUB_C23_R1 from '@/components/OEBPS/9780795325090_epub_c23_r1'
 import OEBPS9780795325090_EPUB_C24_R1 from '@/components/OEBPS/9780795325090_epub_c24_r1'
 import OEBPS9780795325090_EPUB_C25_R1 from '@/components/OEBPS/9780795325090_epub_c25_r1'
 import OEBPSTPB from '@/components/OEBPS/tpb'
 import OEBPSCOPB from '@/components/OEBPS/copb'
 import OEBPSDEDB from '@/components/OEBPS/dedb'
 import OEBPSTOCB from '@/components/OEBPS/tocb'
 import OEBPSACKB from '@/components/OEBPS/ackb'
 import OEBPSFM1B from '@/components/OEBPS/fm1b'
 import OEBPSPROB from '@/components/OEBPS/prob'
 import OEBPSP01B from '@/components/OEBPS/p01b'
 import OEBPSC01B from '@/components/OEBPS/c01b'
 import OEBPSC02B from '@/components/OEBPS/c02b'
 import OEBPSC03B from '@/components/OEBPS/c03b'
 import OEBPSC04B from '@/components/OEBPS/c04b'
 import OEBPSC05B from '@/components/OEBPS/c05b'
 import OEBPSC06B from '@/components/OEBPS/c06b'
 import OEBPSC07B from '@/components/OEBPS/c07b'
 import OEBPSC08B from '@/components/OEBPS/c08b'
 import OEBPSC09B from '@/components/OEBPS/c09b'
 import OEBPSC10B from '@/components/OEBPS/c10b'
 import OEBPSC11B from '@/components/OEBPS/c11b'
 import OEBPSC12B from '@/components/OEBPS/c12b'
 import OEBPSC13B from '@/components/OEBPS/c13b'
 import OEBPSC14B from '@/components/OEBPS/c14b'
 import OEBPSC15B from '@/components/OEBPS/c15b'
 import OEBPSC16B from '@/components/OEBPS/c16b'
 import OEBPSC17B from '@/components/OEBPS/c17b'
 import OEBPSP02B from '@/components/OEBPS/p02b'
 import OEBPSC18B from '@/components/OEBPS/c18b'
 import OEBPSC19B from '@/components/OEBPS/c19b'
 import OEBPSC20B from '@/components/OEBPS/c20b'
 import OEBPSC21B from '@/components/OEBPS/c21b'
 import OEBPSC22B from '@/components/OEBPS/c22b'
 import OEBPSC23B from '@/components/OEBPS/c23b'
 import OEBPSC24B from '@/components/OEBPS/c24b'
 import OEBPSC25B from '@/components/OEBPS/c25b'
 import OEBPSP03B from '@/components/OEBPS/p03b'
 import OEBPSTPC from '@/components/OEBPS/tpc'
 import OEBPSCOPC from '@/components/OEBPS/copc'
 import OEBPSDEDC from '@/components/OEBPS/dedc'
 import OEBPSTOCC from '@/components/OEBPS/tocc'
 import OEBPSP01C from '@/components/OEBPS/p01c'
 import OEBPSC01C from '@/components/OEBPS/c01c'
 import OEBPSC02C from '@/components/OEBPS/c02c'
 import OEBPSC03C from '@/components/OEBPS/c03c'
 import OEBPSC04C from '@/components/OEBPS/c04c'
 import OEBPSC05C from '@/components/OEBPS/c05c'
 import OEBPSC06C from '@/components/OEBPS/c06c'
 import OEBPSC07C from '@/components/OEBPS/c07c'
 import OEBPSC08C from '@/components/OEBPS/c08c'
 import OEBPSC09C from '@/components/OEBPS/c09c'
 import OEBPSC10C from '@/components/OEBPS/c10c'
 import OEBPSC11C from '@/components/OEBPS/c11c'
 import OEBPSC12C from '@/components/OEBPS/c12c'
 import OEBPSC13C from '@/components/OEBPS/c13c'
 import OEBPSC14C from '@/components/OEBPS/c14c'
 import OEBPSC15C from '@/components/OEBPS/c15c'
 import OEBPSC16C from '@/components/OEBPS/c16c'
 import OEBPSC17C from '@/components/OEBPS/c17c'
 import OEBPSC18C from '@/components/OEBPS/c18c'
 import OEBPSC19C from '@/components/OEBPS/c19c'
 import OEBPSC20C from '@/components/OEBPS/c20c'
 import OEBPSC21C from '@/components/OEBPS/c21c'
 import OEBPSC22C from '@/components/OEBPS/c22c'
 import OEBPSP02C from '@/components/OEBPS/p02c'
 import OEBPSC23C from '@/components/OEBPS/c23c'
 import OEBPSC24C from '@/components/OEBPS/c24c'
 import OEBPSC25C from '@/components/OEBPS/c25c'
 import OEBPSC26C from '@/components/OEBPS/c26c'
 import OEBPSC27C from '@/components/OEBPS/c27c'
 import OEBPSC28C from '@/components/OEBPS/c28c'
 import OEBPSC29C from '@/components/OEBPS/c29c'
 import OEBPSC30C from '@/components/OEBPS/c30c'
 import OEBPSC31C from '@/components/OEBPS/c31c'
 import OEBPSP03C from '@/components/OEBPS/p03c'
 import OEBPSC32C from '@/components/OEBPS/c32c'
 import OEBPSC33C from '@/components/OEBPS/c33c'
 import OEBPSC34C from '@/components/OEBPS/c34c'
 import OEBPSC35C from '@/components/OEBPS/c35c'
 import OEBPSC36C from '@/components/OEBPS/c36c'
 import OEBPSC37C from '@/components/OEBPS/c37c'
 import OEBPSP04C from '@/components/OEBPS/p04c'
 import OEBPSC38C from '@/components/OEBPS/c38c'
 import OEBPSC39C from '@/components/OEBPS/c39c'
 import OEBPSC40C from '@/components/OEBPS/c40c'
 import OEBPSC41C from '@/components/OEBPS/c41c'
 import OEBPSC42C from '@/components/OEBPS/c42c'
 import OEBPSC43C from '@/components/OEBPS/c43c'
 import OEBPSC44C from '@/components/OEBPS/c44c'
 import OEBPSACKC from '@/components/OEBPS/ackc'
 import OEBPSAPPC from '@/components/OEBPS/appc'
 import OEBPS9780795325786_EPUB_TP_R1 from '@/components/OEBPS/9780795325786_epub_tp_r1'
 import OEBPS9780795325786_EPUB_COP_R1 from '@/components/OEBPS/9780795325786_epub_cop_r1'
 import OEBPS9780795325786_EPUB_DED_R1 from '@/components/OEBPS/9780795325786_epub_ded_r1'
 import OEBPS9780795325786_EPUB_FM_R1 from '@/components/OEBPS/9780795325786_epub_fm_r1'
 import OEBPS9780795325786_EPUB_TOC_R1 from '@/components/OEBPS/9780795325786_epub_toc_r1'
 import OEBPS9780795325786_EPUB_PRL_R1 from '@/components/OEBPS/9780795325786_epub_prl_r1'
 import OEBPS9780795325786_EPUB_P01_R1 from '@/components/OEBPS/9780795325786_epub_p01_r1'
 import OEBPS9780795325786_EPUB_C01_R1 from '@/components/OEBPS/9780795325786_epub_c01_r1'
 import OEBPS9780795325786_EPUB_C02_R1 from '@/components/OEBPS/9780795325786_epub_c02_r1'
 import OEBPS9780795325786_EPUB_C03_R1 from '@/components/OEBPS/9780795325786_epub_c03_r1'
 import OEBPS9780795325786_EPUB_C04_R1 from '@/components/OEBPS/9780795325786_epub_c04_r1'
 import OEBPS9780795325786_EPUB_C05_R1 from '@/components/OEBPS/9780795325786_epub_c05_r1'
 import OEBPS9780795325786_EPUB_C06_R1 from '@/components/OEBPS/9780795325786_epub_c06_r1'
 import OEBPS9780795325786_EPUB_C07_R1 from '@/components/OEBPS/9780795325786_epub_c07_r1'
 import OEBPS9780795325786_EPUB_C08_R1 from '@/components/OEBPS/9780795325786_epub_c08_r1'
 import OEBPS9780795325786_EPUB_C09_R1 from '@/components/OEBPS/9780795325786_epub_c09_r1'
 import OEBPS9780795325786_EPUB_P02_R1 from '@/components/OEBPS/9780795325786_epub_p02_r1'
 import OEBPS9780795325786_EPUB_C10_R1 from '@/components/OEBPS/9780795325786_epub_c10_r1'
 import OEBPS9780795325786_EPUB_C11_R1 from '@/components/OEBPS/9780795325786_epub_c11_r1'
 import OEBPS9780795325786_EPUB_C12_R1 from '@/components/OEBPS/9780795325786_epub_c12_r1'
 import OEBPS9780795325786_EPUB_C13_R1 from '@/components/OEBPS/9780795325786_epub_c13_r1'
 import OEBPS9780795325786_EPUB_P03_R1 from '@/components/OEBPS/9780795325786_epub_p03_r1'
 import OEBPS9780795325786_EPUB_C14_R1 from '@/components/OEBPS/9780795325786_epub_c14_r1'
 import OEBPS9780795325786_EPUB_C15_R1 from '@/components/OEBPS/9780795325786_epub_c15_r1'
 import OEBPS9780795325786_EPUB_C16_R1 from '@/components/OEBPS/9780795325786_epub_c16_r1'
 import OEBPS9780795325786_EPUB_C17_R1 from '@/components/OEBPS/9780795325786_epub_c17_r1'
 import OEBPS9780795325786_EPUB_C18_R1 from '@/components/OEBPS/9780795325786_epub_c18_r1'
 import OEBPS9780795325786_EPUB_C19_R1 from '@/components/OEBPS/9780795325786_epub_c19_r1'
 import OEBPS9780795325786_EPUB_C20_R1 from '@/components/OEBPS/9780795325786_epub_c20_r1'
 import OEBPS9780795325786_EPUB_C21_R1 from '@/components/OEBPS/9780795325786_epub_c21_r1'
 import OEBPS9780795325786_EPUB_C22_R1 from '@/components/OEBPS/9780795325786_epub_c22_r1'
 import OEBPS9780795325786_EPUB_EPL_R1 from '@/components/OEBPS/9780795325786_epub_epl_r1'
 import LOVE_2 from '@/components/love_2'
 import OEBPS9780795325786_EPUB_ATN_R1 from '@/components/OEBPS/9780795325786_epub_atn_r1'
 import OEBPSNTS from '@/components/OEBPS/nts'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_cvi_r1",
 			"name" : "OEBPS/9780795325090_epub_cvi_r1",
 			"component" : OEBPS9780795325090_EPUB_CVI_R1
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_tp_r1",
 			"name" : "OEBPS/9780795325090_epub_tp_r1",
 			"component" : OEBPS9780795325090_EPUB_TP_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_cop_r1",
 			"name" : "OEBPS/9780795325090_epub_cop_r1",
 			"component" : OEBPS9780795325090_EPUB_COP_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_ded_r1",
 			"name" : "OEBPS/9780795325090_epub_ded_r1",
 			"component" : OEBPS9780795325090_EPUB_DED_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_toc_r1",
 			"name" : "OEBPS/9780795325090_epub_toc_r1",
 			"component" : OEBPS9780795325090_EPUB_TOC_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_atn_r1",
 			"name" : "OEBPS/9780795325090_epub_atn_r1",
 			"component" : OEBPS9780795325090_EPUB_ATN_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_p01_r1",
 			"name" : "OEBPS/9780795325090_epub_p01_r1",
 			"component" : OEBPS9780795325090_EPUB_P01_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c01_r1",
 			"name" : "OEBPS/9780795325090_epub_c01_r1",
 			"component" : OEBPS9780795325090_EPUB_C01_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c02_r1",
 			"name" : "OEBPS/9780795325090_epub_c02_r1",
 			"component" : OEBPS9780795325090_EPUB_C02_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c03_r1",
 			"name" : "OEBPS/9780795325090_epub_c03_r1",
 			"component" : OEBPS9780795325090_EPUB_C03_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c04_r1",
 			"name" : "OEBPS/9780795325090_epub_c04_r1",
 			"component" : OEBPS9780795325090_EPUB_C04_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c05_r1",
 			"name" : "OEBPS/9780795325090_epub_c05_r1",
 			"component" : OEBPS9780795325090_EPUB_C05_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c06_r1",
 			"name" : "OEBPS/9780795325090_epub_c06_r1",
 			"component" : OEBPS9780795325090_EPUB_C06_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c07_r1",
 			"name" : "OEBPS/9780795325090_epub_c07_r1",
 			"component" : OEBPS9780795325090_EPUB_C07_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c08_r1",
 			"name" : "OEBPS/9780795325090_epub_c08_r1",
 			"component" : OEBPS9780795325090_EPUB_C08_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c09_r1",
 			"name" : "OEBPS/9780795325090_epub_c09_r1",
 			"component" : OEBPS9780795325090_EPUB_C09_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c10_r1",
 			"name" : "OEBPS/9780795325090_epub_c10_r1",
 			"component" : OEBPS9780795325090_EPUB_C10_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c11_r1",
 			"name" : "OEBPS/9780795325090_epub_c11_r1",
 			"component" : OEBPS9780795325090_EPUB_C11_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_p02_r1",
 			"name" : "OEBPS/9780795325090_epub_p02_r1",
 			"component" : OEBPS9780795325090_EPUB_P02_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c12_r1",
 			"name" : "OEBPS/9780795325090_epub_c12_r1",
 			"component" : OEBPS9780795325090_EPUB_C12_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c13_r1",
 			"name" : "OEBPS/9780795325090_epub_c13_r1",
 			"component" : OEBPS9780795325090_EPUB_C13_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c14_r1",
 			"name" : "OEBPS/9780795325090_epub_c14_r1",
 			"component" : OEBPS9780795325090_EPUB_C14_R1
 		},
 		{
 			"path" : "/OEBPS/9780795325090_epub_c15_r1",
 			"name" : "OEBPS/9780795325090_epub_c15_r1",
 			"component" : OEBPS9780795325090_EPUB_C15_R1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js